import { onMounted, computed, ref, watch } from 'vue'
import {useStore} from 'vuex'
import router from "@/router"


const useIndex = () => {
    const store = useStore()
    const index_datos = ref({})
    const device_params = ref({})
    onMounted(() => {
        if (store.state.deviceActive == false){
            router.push("/");
        }else {
        index_datos.value = store.state.deviceInfo
        }
    })

    const spiffs_percent_used = computed(() => {
        return index_datos.value["spiffsu"] * 100 / index_datos.value["spiffst"]
    })
    const ram_percent_free = computed(() => {
        return index_datos.value["ram"] * 100 / index_datos.value["ramsz"]
    })


    watch(() => store.state.deviceInfo,
        (data) => {
            index_datos.value = data
        })

    watch(() => store.state.deviceParams,
        (data) => {
            device_params.value = data
        })

    return {
        index_datos,
        device_params,
        spiffs_percent_used,
        ram_percent_free,
    }

}

export default useIndex